/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderCertIcon20Solid = forwardRef('FolderCertIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.5A1.5 1.5 0 0 1 3.5 3h4.3a1.5 1.5 0 0 1 1.205.607l.807 1.09a.75.75 0 0 0 .603.303H15a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3v2.498a.5.5 0 0 1-.765.424l-1.102-.69a.25.25 0 0 0-.265 0l-1.103.69a.5.5 0 0 1-.765-.424V17H5a3 3 0 0 1-3-3V4.5ZM13 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM5 8a.75.75 0 0 0 0 1.5h10A.75.75 0 0 0 15 8H5Z" })));
});
